/**
 * Returns the subdomain the
 * current application is hosted
 * on. This parameter can also
 * be specified using a `?subdomain`
 * search parameter
 */

function getSubdomainParameter(defaultValue = '') {
  const splitted = window.location.hostname.split('.');
  const urlSubdomain = splitted.length >= 3 ? splitted[0] : undefined;
  const searchParams = new URLSearchParams(window.location.search);

  const subdomainSearchParam = searchParams.get('subdomain') ?? '';

  return urlSubdomain || subdomainSearchParam || defaultValue;
}

export type AppStage = 'development' | 'prerelease' | 'production';

export function getAppStage(): AppStage {
  if (process.env['NODE_ENV'] === 'development' || process.env['IS_OFFLINE']) {
    return 'development';
  }

  if (process.env['STAGE'] === 'prerelease' || process.env['STAGE'] === 'staging') {
    return 'prerelease';
  }

  if (typeof window !== 'undefined' && getSubdomainParameter() === 'staging') {
    return 'prerelease';
  }

  return 'production';
}

type CarlitoApis = 'main_content' | 'gateway' | 'carlito_federation' | 'fusionar';

type CarlitoConfig = {
  /**
   * ⚠️ Important! API URIs shouldn't end with a slash
   */
  apiUris: Record<
    CarlitoApis,
    {
      production: string;
      prerelease: string;
      development: string;
    }
  >;
};

const carlitoConfig: CarlitoConfig = {
  apiUris: {
    carlito_federation: {
      production: 'https://federation.carlito-app.com/production',
      prerelease: 'https://federation.carlito-app.com/prerelease',
      development: 'http://localhost:4444',
    },
    main_content: {
      development: 'http://127.0.0.1:1337',
      prerelease: 'https://api.carlito-app.com',
      production: 'https://api.carlito-app.com',
    },
    gateway: {
      development: 'http://localhost:3006',
      prerelease: 'https://1aby440p2i.execute-api.eu-central-1.amazonaws.com/prerelease',
      production: 'https://epificcu94.execute-api.eu-central-1.amazonaws.com/production',
    },
    fusionar: {
      development: 'http://localhost:3000',
      prerelease: 'https://bn6vkhq2u0.execute-api.eu-central-1.amazonaws.com/prerelease',
      production: 'https://mvcskh5wma.execute-api.eu-central-1.amazonaws.com/production',
    },
  },
};

export function getApiUri(api: CarlitoApis, stage: AppStage = getAppStage()) {
  return carlitoConfig.apiUris[api][stage];
}
